import { TYPES } from "@actions/cart-actions";
import INITIAL_STATE from "./initial-state";

const cartReducer = (state = INITIAL_STATE.cart, action) => {
  switch (action.type) {
    case TYPES.OPEN_SALES_CART_MODAL: {
      return {
        ...state,
        isCartModalOpen: true,
      };
    }

    case TYPES.CLOSE_SALES_CART_MODAL: {
      return {
        ...state,
        isCartModalOpen: false,
      };
    }

    case TYPES.SET_PENDING_SALES_CART: {
      const { cart } = action;
      return {
        ...state,
        pendingCart: cart,
      };
    }

    case TYPES.SET_USE_PURCHASE_CREDIT: {
      const { usePurchaseCredit } = action;
      return {
        ...state,
        usePurchaseCredit,
      };
    }

    default:
      return state;
  }
};

export default cartReducer;
